import React, { useState } from 'react';
import { Editor, Block } from '@/components/editor/Editor';

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
export default function DocumentBlockTestPage() {
  const { t } = usePlatformTranslation();
  const [blocks, setBlocks] = useState<Block[]>([
    { id: '1', type: 'text', content: 'Test document block functionality' },
    { 
      id: '2', 
      type: 'document', 
      content: '9a299a40-5ef4-417c-b492-bb6df68d39fa', // Example glossary item ID
      metadata: {
        blockType: 'glossary-reference',
        glossaryItemId: '9a299a40-5ef4-417c-b492-bb6df68d39fa',
        glossaryItemName: 'Test Document'
      }
    }
  ]);

  const handleChange = (newBlocks: Block[]) => {
    setBlocks(newBlocks);
    console.log('Blocks updated:', newBlocks);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">{t('platform.pages.test_pages.document_block_test')}</h1>
        <div className="bg-white rounded-lg shadow-lg p-6">
          <Editor 
            initialBlocks={blocks}
            onChange={handleChange}
          />
        </div>
        
        <div className="mt-8 bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold mb-4">{t('platform.pages.test_pages.current_blocks_state')}</h2>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto">
            {JSON.stringify(blocks, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
} 